// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3lHhr","errorLogs":"EditorFooter_errorLogs__TDT5-"};